import { useEffect, useRef, useState } from 'react';

import { apiUrl, fetchJson } from '../../apiBase';
import { normalizeSortOrder } from './assessmentUiUtils';

const useMaarifLearningActivities = ({ learningAreaId, notifyError }) => {
  const [activities, setActivities] = useState([]);
  const [loadingActivities, setLoadingActivities] = useState(false);
  const reqIdRef = useRef(0);

  useEffect(() => {
    setActivities([]);

    if (!learningAreaId) return;

    const rid = ++reqIdRef.current;
    const run = async () => {
      setLoadingActivities(true);
      try {
        const res = await fetchJson(
          apiUrl(
            `/admin/maarif/learning-areas/${encodeURIComponent(learningAreaId)}/learning-activities`
          )
        );
        if (rid !== reqIdRef.current) return;
        if (!res.ok) throw new Error('activities');
        const rows = await res.json();
        const items = (rows || [])
          .filter((r) => r && r.id != null)
          .map((r) => ({
            id: r.id,
            name: String(r.name || ''),
            sort_order: normalizeSortOrder(r.sort_order),
            is_active: !!r.is_active,
          }))
          .filter((r) => r.name)
          .sort(
            (a, b) =>
              a.sort_order - b.sort_order ||
              String(a.id).localeCompare(String(b.id), 'tr-TR') ||
              a.name.localeCompare(b.name, 'tr-TR')
          );
        setActivities(items);
      } catch (e) {
        if (rid !== reqIdRef.current) return;
        notifyError && notifyError('Öğrenme etkinlikleri yüklenemedi');
        setActivities([]);
      } finally {
        if (rid !== reqIdRef.current) return;
        setLoadingActivities(false);
      }
    };

    run();
  }, [learningAreaId, notifyError]);

  return { activities, loadingActivities };
};

export default useMaarifLearningActivities;
